import { ReactNode } from 'react';
import styled from '@emotion/styled/macro';
import { theme } from '@arnold/common/lib/theme';

const Image = styled.div`
  display: none;

  @media (min-width: 686px) {
    display: block;
  }
`;

const Banner = styled.div`
  width: 100%;
  background-color: white;
  border-top: 1px solid #f9f9f9;
`;

const Content = styled.div`
  max-width: 960px;
  width: 90vw;
  margin-left: auto;
  margin-right: auto;
  padding: 32px;
  display: flex;
  flex-direction: row;
  border: 1px solid ${theme.colors.borderMain.default};
  border-radius: ${theme.borderRadius.l};
  margin-bottom: ${theme.spacing.f};
`;

const Text = styled.div`
  flex: 1;
  text-align: justify;

  @media (min-width: 686px) {
    margin-left: 88px;
    text-align: left;
  }
`;

interface IProps {
  image: ReactNode;
  text: ReactNode;
  dataIcom?: string;
}

const RowBanner = ({ image, text, dataIcom }: IProps) => {
  return (
    <Banner>
      <Content data-icom={dataIcom}>
        <Image>{image}</Image>
        <Text>{text}</Text>
      </Content>
    </Banner>
  );
};

export default RowBanner;
